import SupplierOrdersPage from "../components/pages/supplierOrders/SupplierOrdersPage";

const routes = [
    {
        path: "/supplierOrders",
        element: <SupplierOrdersPage />
    }
];

export default routes;
